import React, {Component} from 'react';
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import machinery from '../../images/machinery.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import {CSVLink} from 'react-csv';

import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import pt from "date-fns/locale/pt-BR";
registerLocale("pt", pt);


class ChecklistMaquinas extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.showDiv12= this.showDiv12.bind(this);
        this.showDiv13= this.showDiv13.bind(this);
        this.showDiv14= this.showDiv14.bind(this);
        this.showDiv15= this.showDiv15.bind(this);
        this.showDiv16= this.showDiv16.bind(this);
        this.showDiv17= this.showDiv17.bind(this);
        this.showDiv18= this.showDiv18.bind(this);

        this.state ={

            showComponent12: false, /*maquinas e equipamentos*/
            showComponent13: false,
            showComponent14: false,
            showComponent15: false,
            showComponent16: false,
            showComponent17: false,
            showComponent18: false,

            data: [
                { pergunta: "Os manuais de instrução dos equipamentos estão disponíveis para os operadores?", resposta: "Sim ou não"},
                { pergunta: "Os tratores são equipados com cabine de segurança (ROPS) para evitar esmagamento ou afogamento em caso de capotamento?", resposta: "Sim ou não"},
                { pergunta: "Os equipamentos estão em boas condições mecânicas e possuem proteção de segurança para evitar acidentes?", resposta: "Sim ou não"},
                { pergunta: "Os operadores de máquinas e equipamentos estão cientes dos riscos?"
                        , resposta: "Sim ou não" },
                { pergunta: "Os operadores foram treinados para utilização das máquinas e equipamentos que utilizam?", resposta: "Sim ou não"},
                { pergunta: "Os guinchos hidráulicos são abaixados no final de uma tarefa e as cargas suspensas nunca são deixadas desacompanhadas?", resposta: "Sim ou não"},
                { pergunta: "Os procedimentos adequados de bloqueio (tagout) são usados em máquinas e equipamentos?", resposta: "Sim ou não"}
            ],

        }
    }



    csvHeaders=[
        {label: 'nome', key: 'nome'},
        {label: 'data', key: 'data'}
    ];

    csvData=[

        {label: 'forms Maquinas', key: 'formsWorks' }
    ];

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };


    /***machinery***/

    showDiv12 = (e) => {
        this.setState({
            showComponent12: e.target.checked,
        });
    };

    showDiv13 = (e) => {
        this.setState({
            showComponent13: e.target.checked,
        });
    };

    showDiv14 = (e) => {
        this.setState({
            showComponent14: e.target.checked,
        });
    };

    showDiv15 = (e) => {
        this.setState({
            showComponent15: e.target.checked,
        });
    };


    showDiv16 = (e) => {
        this.setState({
            showComponent16: e.target.checked,
        });
    };

    showDiv17 = (e) => {
        this.setState({
            showComponent17: e.target.checked,
        });
    };

    showDiv18 = (e) => {
        this.setState({
            showComponent18: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };
    render(){


        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});

        return(
            <Card>

                <Row>
                    <div className={"text-center"} align={"center"}>
                        <img src={machinery} className={"img"} alt={"Machinery logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>

                <div id={"printDiv"}>

                    <div align={"center"}>
                    <h5><b><FormattedMessage id={"mac.ch"} defaultMessage={"Checklist Máquinas e Equipamentos"}/></b></h5>
                    </div>

                   <input type={"text"} placeholder={placeholder} key={"nome"} />

                  <React.Fragment>{

                      intl.locale==="en" ?

                <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                            onChange={this. handleChangeDatePicker}/> :

                          <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                      onChange={this. handleChangeDatePicker}/>
                  }</React.Fragment>


                    <div className={"margin"}>
                        <b><FormattedMessage id={"mac.ch"} defaultMessage={"Checklist Máquinas e Equipamentos"}/></b></div>

                    <div className={"machinery1"}>

                        <form action={"#"} className={"formsWorks"} key={"formsWorks"}>

                            <p><FormattedMessage id={"mac.ch1"} defaultMessage={"Os manuais de instrução dos equipamentos estão disponíveis para os operadores?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes12"}/>

                            <label htmlFor={"yes12"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no12"} onClick={this.showDiv12}/>

                                <label htmlFor={"no12"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent12 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                        </form>
                    </div>

                    <div className={"machinery2"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch2"} defaultMessage={"Os tratores são equipados com cabine de segurança (ROPS) para evitar esmagamento ou afogamento em caso de capotamento?"}/></p>

                            <input type={"checkbox"} id={"yes13"}/>

                            <label htmlFor={"yes13"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no13"} onClick={this.showDiv13}/>

                                <label htmlFor={"no13"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent13 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"machinery3"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch3"} defaultMessage={"Os equipamentos estão em boas condições mecânicas e possuem proteção de segurança para evitar acidentes?"}/></p>

                            <input type={"checkbox"} id={"yes14"}/>

                            <label htmlFor={"yes14"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no14"} onClick={this.showDiv14}/>

                                <label htmlFor={"no14"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent14 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"machinery4"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch4"} defaultMessage={"Os operadores de máquinas e equipamentos estão cientes dos riscos?"}/></p>

                            <input type={"checkbox"} id={"yes15"}/>

                            <label htmlFor={"yes15"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no15"} onClick={this.showDiv15}/>

                                <label htmlFor={"no15"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent15 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"machinery5"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch5"} defaultMessage={"Os operadores foram treinados para utilização das máquinas e equipamentos que utilizam?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes16"}/>

                            <label htmlFor={"yes16"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no16"} onClick={this.showDiv16}/>

                                <label htmlFor={"no16"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent16 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>

                    <div className={"machinery6"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch6"} defaultMessage={"Os guinchos hidráulicos são abaixados no final de uma tarefa e as cargas suspensas nunca são deixadas desacompanhadas?"}/></p>

                            <input type={"checkbox"} id={"yes17"}/>

                            <label htmlFor={"yes17"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no17"} onClick={this.showDiv17}/>

                                <label htmlFor={"no17"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent17 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"machinery7"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"mac.ch7"} defaultMessage={"Os procedimentos adequados de bloqueio (tagout) são usados em máquinas e equipamentos?"}/></p>

                            <input type={"checkbox"} id={"yes18"}/>

                            <label htmlFor={"yes18"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no18"} onClick={this.showDiv18}/>

                                <label htmlFor={"no18"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent18 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>

                </div>

                <br/>

                <Button className={"button"} onClick={this.handleDownloadPDF} >
                   PDF
                </Button>




                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                        CSV
                    </Button> </CSVLink>

            </Card>
        )}

}

export default injectIntl(ChecklistMaquinas);